import { CreatorShopMembershipPage } from './CreatorShopMembershipPage';
import { CreatorShopSupportPage } from './CreatorShopSupportPage';
import { CreatorShopCommissionPage } from './CreatorShopCommissionPage';

export const creatorShopMembershipRouter = {
  '/membership/main': CreatorShopMembershipPage,
  '/membership/support': CreatorShopSupportPage,
  '/membership/commission': CreatorShopCommissionPage,
};
